// Contact address shown when something needs a human (VITE_CONTACT_EMAIL, set
// in Vercel). Undefined when not configured: callers then leave it out.
export const CONTACT_EMAIL = import.meta.env.VITE_CONTACT_EMAIL;

export const contactHref = (subject, body = '') =>
  CONTACT_EMAIL
    ? `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}${body ? `&body=${encodeURIComponent(body)}` : ''}`
    : null;
